import angular from 'angular';
import uiRouter from 'angular-ui-router';
import AgencyComponent from './agency.component';

let AgencyModule = angular
  .module('Agency', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newAgency', {
        url: '/agencies/new',
        component: 'agency',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editAgency', {
        url: '/agencies/:id',
        component: 'agency',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          agency: (AgenciesService, $stateParams) => {
            return AgenciesService.findById($stateParams.id);
          }
        }
      });
  })
  .component('agency', AgencyComponent).name;

export default AgencyModule;
